import { formatDeviceTimeZone } from './formatDeviceTimeZone';
import { getDefaultLanguage } from './getDefaultLanguage';
import { getCSRF, getDeviceId } from './getHttpcon';
import { getSkyfireAuthentication } from './getSkyfireAuthentication';
import { globals } from './globals';
export async function getSkyfireHeaders(authentication, templateStack) {
    var _a, _b, _c, _d;
    const csrf = await getCSRF(authentication);
    const deviceId = await getDeviceId(authentication);
    const now = new Date();
    const isInitialPageLoad = !((_b = (_a = templateStack) === null || _a === void 0 ? void 0 : _a.previousTemplate) === null || _b === void 0 ? void 0 : _b.innerTemplate);
    return {
        'x-amzn-authentication': getSkyfireAuthentication(authentication),
        'x-amzn-device-model': 'WEBPLAYER',
        'x-amzn-device-width': '1920',
        'x-amzn-device-family': authentication.deviceType === 'A34OIAVFALWTNH' ? 'MobileWebPlayer' : 'WebPlayer',
        'x-amzn-device-id': deviceId,
        'x-amzn-user-agent': convertToAscii(globals.navigator.userAgent),
        'x-amzn-session-id': authentication.sessionId,
        'x-amzn-device-height': '1080',
        'x-amzn-request-id': `${generateRequestId()}`,
        'x-amzn-device-language': authentication.displayLanguageId || getDefaultLanguage(authentication.marketplaceId),
        'x-amzn-os-version': '1.0',
        'x-amzn-application-version': `${globals.amznMusic.appConfig.version}`,
        'x-amzn-device-time-zone': formatDeviceTimeZone(now.getTimezoneOffset()),
        'x-amzn-timestamp': `${Date.now()}`,
        'x-amzn-csrf': csrf,
        'x-amzn-music-domain': globals.location.hostname,
        'x-amzn-referer': getReferer(authentication, isInitialPageLoad),
        'x-amzn-affiliate-tags': (_d = decodeURIComponent((_c = authentication.metricsContext) === null || _c === void 0 ? void 0 : _c.affiliateTags), (_d !== null && _d !== void 0 ? _d : '')),
        'x-amzn-page-url': parseLocation(globals.location.href),
        'x-amzn-weblab-id-overrides': getCookie('experiment').replace(/"/g, ''),
    };
}
function getCookie(name) {
    const cookieRegex = new RegExp(`${name}=([^;]+)`);
    const cookie = cookieRegex.exec(globals.document.cookie);
    return (cookie && cookie[1]) || '';
}
function getReferer(authentication, isInitialPageLoad) {
    var _a, _b, _c;
    if (isInitialPageLoad) {
        return ((_a = authentication.metricsContext) === null || _a === void 0 ? void 0 : _a.referer) ? new URL(authentication.metricsContext.referer).hostname
            : '';
    }
    else {
        return _c = (_b = globals.location) === null || _b === void 0 ? void 0 : _b.hostname, (_c !== null && _c !== void 0 ? _c : '');
    }
}
function convertToAscii(str) {
    return str.replace(/[^\x00-\x7F]/g, (c) => unescape(encodeURIComponent(c)));
}
function generateRequestId() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        // tslint:disable-next-line: no-bitwise
        const r = (Math.random() * 16) | 0;
        // tslint:disable-next-line: no-bitwise
        const v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses location href to remove hash section.
 * Certain service frameworks (e.g. Spring) do not recognize the section of a URL following a '#'.
 *
 * @param href location href to parse
 * @returns parsed location href
 */
function parseLocation(href) {
    if (href.indexOf('#') === -1) {
        return href;
    }
    const url = href.split('#')[0];
    const query = href.indexOf('?') === -1 ? '' : href.split('?')[1];
    return query ? `${url}?${query}` : url;
}
